// extracted by mini-css-extract-plugin
module.exports = {"content":"Carousel_content__15sos","carouselWrapper":"Carousel_carouselWrapper__3s4QI","ball":"Carousel_ball__2FR8t","nav":"Carousel_nav__1bu79","active":"Carousel_active__1efNx"};